module.exports = __webpack_public_path__ + "img/W-hf5bm.277e5c3a.jpg";